import React, { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Butiran from "@/components/Butiran";
import StickyCta from "@/components/StickyCta";
import { initAnalytics } from "@/lib/analytics";

const Posters = lazy(() => import("@/components/Posters"));
const Tiket = lazy(() => import("@/components/Tiket"));
const SuperVip = lazy(() => import("@/components/SuperVip"));
const Ingatan = lazy(() => import("@/components/Ingatan"));
const Faq = lazy(() => import("@/components/Faq"));
const Footer = lazy(() => import("@/components/Footer"));
const Admin = lazy(() => import("@/components/Admin"));

function Landing() {
  return (
    <div className="page" data-testid="app-root">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Butiran />
        <Suspense fallback={<div className="lazy-hold" aria-hidden="true" />}>
          <Posters />
          <Tiket />
          <SuperVip />
          <Ingatan />
          <Faq />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <StickyCta />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  // Sandaran: /?admin=1 atau #admin berfungsi walaupun pelayan tiada
  // penulisan semula laluan SPA untuk /admin. Hash dipantau supaya ia
  // bertindak walaupun ditukar tanpa muat semula halaman.
  const readWantsAdmin = () => {
    if (typeof window === "undefined") return false;
    return (
      new URLSearchParams(window.location.search).get("admin") === "1" ||
      window.location.hash === "#admin"
    );
  };
  const [wantsAdmin, setWantsAdmin] = useState(readWantsAdmin);

  useEffect(() => {
    const sync = () => setWantsAdmin(readWantsAdmin());
    window.addEventListener("hashchange", sync);
    window.addEventListener("popstate", sync);
    return () => {
      window.removeEventListener("hashchange", sync);
      window.removeEventListener("popstate", sync);
    };
  }, []);

  if (wantsAdmin) {
    return (
      <Suspense fallback={<div className="lazy-hold" aria-hidden="true" />}>
        <Admin />
      </Suspense>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/admin"
          element={
            <Suspense fallback={<div className="lazy-hold" aria-hidden="true" />}>
              <Admin />
            </Suspense>
          }
        />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
